import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 申請台帳 */
enum Space {
  /** 本台帳 */
  protected = '1',
  /** 仮台帳 */
  unprotected = '2',
}

const nameConfig = {
  protected: new Map([
    [Locale.ja, '本台帳'],
    [Locale.en, 'Main Ledger'],
  ]),
  unprotected: new Map([
    [Locale.ja, '仮台帳'],
    [Locale.en, 'Provisional Ledger'],
  ]),
};

const toEnum = rawValueToEnum(Space, Space.protected);
const toDisplay = enumToName(Space, nameConfig);

export const space = {
  enum: Space,
  nameConfig,
  toEnum,
  toDisplay,
};

export type { Space };
